/* "Abrir na listagem" (cockpit): as listagens aceitam ?chave= e ?transactionId= para já abrir filtradas */
const ACCESS_KEY_PARAM = 'chave';
const TRANSACTION_ID_PARAM = 'transactionId';

export const readListingQuery = (search: string) => {
    const params = new URLSearchParams(search);
    return {
        accessKey: params.get(ACCESS_KEY_PARAM) || '',
        transactionId: params.get(TRANSACTION_ID_PARAM) || ''
    };
}

/* a chave identifica o documento; sem ela (antes da autorização pode não haver) vai o transactionId */
export const buildListingQuery = (accessKey?: string, transactionId?: string) => {
    const params = new URLSearchParams();
    if (accessKey) {
        params.set(ACCESS_KEY_PARAM, accessKey);
    } else if (transactionId) {
        params.set(TRANSACTION_ID_PARAM, transactionId);
    }
    return params.toString() ? `?${params.toString()}` : '';
}

/* valor dos chips de chave/id dos filtros, que guardam a lista separada por vírgula */
export const splitFilterValues = (value?: string) => value ? value.split(',').filter(v => !!v) : [];
